import { mapActions, mapState } from 'vuex'
import api from '@/api'
import LoginOverlay from '@/components/overlays/LoginOverlay'
import { includes } from 'lodash'

export default {
  metaInfo() {
    return {
      title: this.$t('meta.page.title', { name: this.page ? this.page.title : '' }),
    }
  },
  components: {
    ComponentLoader: () => import('@/components/modules/ComponentLoader'),
    NewsIntro: () => import('@/components/modules/NewsIntro'),
    LoginOverlay,
  },
  data() {
    return {
      isArticle: false,
      openedPanel: null,
      comments: {
        data: {},
      },
      likes: {
        data: {},
      },
      funding: false,
      limitedContent: false,
      showLoginOverlay: null,
    }
  },
  computed: {
    ...mapState('pages', [ 'page' ]),
    ...mapState('auth', { activeUser: 'status' }),
    ...mapState('auth', [ 'settings' ]),
    filteredModules() {
      return this.page.modules.filter(module => module.id)
    },
  },
  watch: {
    '$route.hash'() {
      this.checkHash()
    },
    '$route.params.id'() {
      this.requestData()
    },
    openedPanel(val) {
      this.commentClicked = val === 'comments'
    },
  },
  mounted() {
    this.requestData()
    this.checkHash()
  },
  destroyed() {
    this.clearPage()
  },
  methods: {
    ...mapActions('pages', [
      'clearPage',
      'getPage',
    ]),
    ...mapActions('posts', [ 'deleteComment' ]),
    checkHash() {
      const hash = this.$route.hash
      if (hash) {
        this.togglePanel(hash.substring(1), true)
      }
    },
    checkVisibility: function() {
      const hasShareOptions = this.settings.share_options && this.settings.share_options.length
      const isPrivatePage = !this.page || this.page.visibility !== 'all'
      const redirectQuery = { redirect: window.location.pathname.split('/').slice(2).join('/') }
      if (!this.activeUser) {
        if (!hasShareOptions && isPrivatePage) {
          this.$router.replace({ name: 'login', query: redirectQuery },
          )
        } else if (this.page.visibility !== 'all') {
          this.showLoginOverlay = true
          if (!this.$route.query.redirect) {
            this.$router.replace({ query: redirectQuery },
            )
          }
        }
        this.toggleBodyClass('meta', true)
      }
       // Store indicator for non logged in user on a pseudo public page
      this.limitedContent = !(this.activeUser || !isPrivatePage)
    },
    requestData() {
      this.getPage(this.$route.params.id).then(_ => {
        this.checkVisibility()
        if (!this.limitedContent) {
          if (!Object.prototype.hasOwnProperty.call(this.page, 'likes_allowed') || this.page.likes_allowed) {
            this.fetchLikes()
          }
          if (this.page.comments_allowed) {
            this.fetchComments()
          }
        }
        this.isArticle = this.page.meta && this.page.meta.type && this.page.meta.type === 'article'
      })
    },
    async fetchComments() {
      api.items.getItems('comments', { type: 'news', id: this.page.id }).then(({ data }) => {
        this.comments.data = data
      })
    },
    async fetchLikes() {
      api.items.getItems('likes', { type: 'news', id: this.page.id }).then(({ data }) => {
        this.likes.data = data
      })
    },
    onLike(val) {
      api.items.editItem('likes', { type: 'news', id: this.page.id, like: val }).then(({ data }) => {
        this.likes.data = data
      })
    },
    onComment(val) {
      api.items.editItem('comments', { type: 'news', id: this.page.id, like: val }).then(({ data }) => {
        this.comments.data = data
      })
    },
    togglePanel(val, forceJump) {
      if (!includes(val, 'module_')) {
        this.openedPanel = this.openedPanel === val ? null : val
        this.$nextTick(() => {
          const elem = document.querySelector('.cta-panel')
          if (elem) {
            elem.scrollIntoView()
          } else if (forceJump) {
            const that = this
            setTimeout(
              function() {
                that.togglePanel(val, forceJump)
              },
              500,
            )
          }
        })
      } else {
        this.$nextTick(() => {
          const elem = document.querySelector(`#${val}`)
          if (elem) {
            elem.scrollIntoView()
          } else {
            const that = this
            setTimeout(
              function() {
                that.togglePanel(val)
              },
              500,
            )
          }
        })
      }
    },
    onDeleteComment(selectedCommentId, postId) {
      this.deleteComment(selectedCommentId).then(_ => {
        api.items.getItems('comments', { type: 'news', id: postId }).then(({ data }) => {
          this.comments.data = data
        })
      })
    },
  },
}
